import { type Axios, type AxiosStatic } from "axios";

async function getPageContent(axios: Axios, page: string, lang: string) {
  const resp = await axios.get(`/client?page=${page}&lang=${lang}`);
  resp.data.elements = resp.data.elements ?? {};
  return resp.data;
}

function savePageContent(
  axios: Axios,
  page: string,
  lang: string,
  element: string,
  value: string,
) {
  const request = {
    page: page,
    lang: lang,
    element: element,
    value: value,
  };
  axios.post("/client", request);
}

function savePageContentBatch(
  axios: Axios,
  list: {
    page: string;
    lang: string;
    element: string;
    value: string;
  }[],
) {
  axios.post("/client/batch", list);
}

async function deletePageContent(
  axios: Axios,
  page: string,
  lang: string,
  element: string,
) {
  const request = {
    page: page,
    lang: lang,
    element: element,
  };
  const resp = await axios.delete("/client", { data: request });
  return resp.status.toString(10).startsWith("2");
}

async function deletePageContentBatch(
  axios: AxiosStatic,
  list: {
    page: string;
    lang: string;
    element: string;
  }[],
) {
  const resp = await axios.delete("/client/batch", { data: list });
  return resp.status.toString(10).startsWith("2");
}

export function usePageContent() {
  return {
    getPageContent,
    savePageContent,
    savePageContentBatch,
    deletePageContent,
    deletePageContentBatch,
  };
}
